import { COLORS } from '../../lib/theme'

/**
 * The label above a marker or pin.
 *
 * Dark and translucent rather than a light surface chip: these sit directly on
 * terrain and aerial imagery, where a solid pale chip reads as a hole punched in the
 * map. The viewer's own marker uses the primary colour so they can find themselves
 * without reading every chip.
 */
export function ReplayNameChip({ children, me }: { children: string; me?: boolean }) {
  return (
    <span
      style={{
        fontSize: 10,
        fontWeight: me === true ? 700 : 600,
        color: '#fff',
        background: me === true ? COLORS.primary : 'rgba(26,29,28,0.6)',
        padding: '1px 5px',
        borderRadius: 4,
        whiteSpace: 'nowrap',
      }}
    >
      {children}
    </span>
  )
}
